module.exports = __webpack_public_path__ + "static/img/zepto.2051bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zepto.png
// module id = uyCM
// module chunks = 0